export default {"src":"/_next/static/media/wave.04a842ef.svg","height":720,"width":849,"blurWidth":0,"blurHeight":0};